import markerSvg from "@/components/sketch/assets/marker.svg?raw"
import { cn } from "@/lib/utils"

type Props = {
  color: string
  className?: string
}

/** Marker tip icon; tip fill uses currentColor from `color`. Source: assets/marker.svg */
export function SketchMarkerIcon({ color, className }: Props) {
  return (
    <span
      aria-hidden
      className={cn("inline-flex [&>svg]:h-full [&>svg]:w-full", className)}
      style={{ color }}
      dangerouslySetInnerHTML={{ __html: markerSvg }}
    />
  )
}
